import 'twin.macro';
import React, { useEffect } from 'react';
import SimpleNarrowPage from '@teetsh/app/src/components/Layouts/SimpleNarrowPage';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import tw from 'twin.macro';
import { NewOptionCard } from '@teetsh/app/src/components/Cards/NewOptionCard';
import {
  NewFDPFromScratchIllustration,
  NewFDPFromTemplateIllustration,
} from 'containers/Sequences/Home/SequencesIllustrations';
import { useCreateStandaloneFicheDePrep } from 'queries/fdp/useCreateStandaloneFicheDePrep';
import { emptyFicheDePrep } from '../../FolderContent/CreateButton';
import { OnboardingModulePageWrapper } from 'components/OnboardingModulePageWrapper';
import { useHasAccessToFDPTemplates } from 'containers/Sequences/queries/useHasAccessToFDPTemplates';

export function NewFdpStart() {
  const navigate = useNavigate();
  const { t } = useTranslation(['sequence', 'common']);

  const { mutateAsync: createStandaloneFicheDePrep } =
    useCreateStandaloneFicheDePrep();

  const onCreateStandaloneFicheDePrep = () =>
    createStandaloneFicheDePrep({
      ficheDePrep: emptyFicheDePrep(),
      folderId: undefined,
    }).then(newFdp => navigate(`/fiches-de-prep/${newFdp.id}`));

  const hasAccessToFDPTemplates = useHasAccessToFDPTemplates();
  useEffect(() => {
    if (hasAccessToFDPTemplates === false) {
      onCreateStandaloneFicheDePrep();
    }
  }, [hasAccessToFDPTemplates]);

  if (!hasAccessToFDPTemplates) {
    return (
      <OnboardingModulePageWrapper
        title={t('sequence:createNewFdp')}
        onBack={() => navigate(-1)}
      >
        <SimpleNarrowPage width="5xl">
          <div tw="mx-auto max-w-5xl grid items-center justify-center grid-cols-2 gap-6">
            <div className="tsh-skeleton" tw="aspect-[3/2]" />
            <div className="tsh-skeleton" tw="aspect-[3/2]" />
          </div>
        </SimpleNarrowPage>
      </OnboardingModulePageWrapper>
    );
  }

  return (
    <OnboardingModulePageWrapper
      title={t('sequence:createNewFdp')}
      onBack={() => navigate(-1)}
    >
      <SimpleNarrowPage width="5xl">
        <div
          css={[
            tw`mb-6 text-center text-balance grid justify-center gap-4 grid-cols-1 auto-rows-fr lg:grid-cols-2`,
          ]}
        >
          <NewOptionCard
            title={t('sequence:fromScratch')}
            description={t('sequence:fdpFromScratchDescription')}
            icon={<NewFDPFromScratchIllustration />}
            onClick={() => onCreateStandaloneFicheDePrep()}
          />
          <NewOptionCard
            title={t('sequence:fdpUseTemplate')}
            description={t('sequence:fdpUseTemplateDescription')}
            icon={<NewFDPFromTemplateIllustration />}
            onClick={() => navigate('/fiches-de-prep/new/with-template')}
          />
        </div>
      </SimpleNarrowPage>
    </OnboardingModulePageWrapper>
  );
}
